






































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HTTP from '@/plugins/axios'

@Component
export default class ViewRespaldos extends Vue {
  private name: string = 'ViewRespaldos'
  private tab: number = 1

  private tableRespaldos: any[] = []
  private headers: any[] = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: true,
      value: 'fecha'
    },
    { text: 'Evento Taquilla', value: 'evento' },
    { text: 'Fecha', value: 'fechaEvento' },
    { text: 'Acciones', value: 'acciones' }
  ]

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.gShowAllRespaldos()
  }

  private gShowAllRespaldos () {
    console.log('gShowAllRespaldos :: ')
    HTTP.get('respaldo/all')
      .then((response) => {
        console.log('gShowAllRol :: response :: ', response.data)
        this.tableRespaldos = response.data
      })
      .catch((e) => {
        console.log('gShowAllRol :: catch :: ', e.response.data)
      })
  }
}
